(function () {
    'use strict';

    angular
        .module('app')
        .directive('gridSettings', gridSettings);

    gridSettings.$inject = ['$filter', 'columnSetService', 'loginService'];

    function gridSettings($filter, columnSetService, loginService) {
        // Usage:
        //     <gridSettings></gridSettings>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                onOk: "=?",
                onCancel: "=?",
                dialogShown: "=?",
                columnDefs: "=",
                allColumnDefs: "=",
                onApplySettings: "&",
                columnSets: '='
            },
            templateUrl: 'app/gridsettings/templates/gridsettings.html',
            controller: 'gridsettings',
        };
        return directive;

        function link(scope, element, attrs) {

            scope.columnDefs = $filter('filter')(scope.columnDefs, function (column) {
                if (column.name || column.field == "GLYPH_TYPE") {
                    return column;
                }
                else {
                    return null;
                }
            });

            scope.allColumnDefs = $filter('filter')(scope.allColumnDefs, function (column) {
                if (column.name) {
                    return column;
                }
                else {
                    return null;
                }
            });

            ////loginService.initStrings().then(function () {
            //vm.gridSettingsLabel = loginService.resourceStrings["GRID_SETTINGS"]; // "Grid Settings"
            //vm.columnsLabel = loginService.resourceStrings["COLUMNS"]; // "Columns"
            //vm.columnSetsLabel = loginService.resourceStrings["COLUMN_SETS"]; // "Column Sets"
            ////});
        }
    }

})();